import { store } from '../store/store';
/** A token refresh is allowed; changing account, active role or report permissions invalidates downloads. */
export function reportSessionKey(): string {
  const auth = store.getState().auth as Record<string, unknown>;
  return JSON.stringify([auth?.userId, auth?.userRole, auth?.canViewFinancialDashboard,
    auth?.canViewPayrollDashboard, auth?.canManageFinancialCloseout, auth?.canManageGusto]);
}
export function assertReportSession(session: string): void {
  if (session !== reportSessionKey()) throw new Error('Your account or permissions changed. Refresh before exporting.');
}
